/*
 *
 * Copyright (C) 2022 NetBase Solutions, Inc.
 * 3960 Freedom Circle Suite 201 Santa Clara, CA 95054
 * All rights reserved.
 */

import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import { useDashboardWidgetSetting } from '../../../../hooks/useDashboardState'
import ErrorMessage from '../../../share/ErrorMessage'

const MeasureTypesEmptyGuard = ({ widgetId, children }) => {
  const { measureTypes } = useDashboardWidgetSetting(widgetId)
  const { t } = useTranslation()

  if (!measureTypes?.length) return <ErrorMessage>{t('noDataFoundInWidget')}</ErrorMessage>

  return children
}

MeasureTypesEmptyGuard.propTypes = {
  widgetId: PropTypes.number.isRequired,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.elementType]).isRequired
}
export default MeasureTypesEmptyGuard
